export default "__VITE_ASSET__BYaw0paY__"